import React from 'react';

export default function UnpkgPlayer(props){
    const iframeSource = props.iframeSource || 'https://cdn.azotosolutions.com/cloudtv/livetv13/player';
    const styleObj = {
    	"width" : "100%",
    	"height": "200px",
    	"overflow" : "hidden",
    	"border" : "none"
    };
    return <iframe style={styleObj} id={'iframe-azoto'} src={iframeSource} allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" />  
}